import Vue from 'vue';
import tippy from 'tippy.js';
import objectFitImages from 'object-fit-images';
import JSONAPISerializer from 'jsonapi-serializer';
import 'svgxuse';

import UserSettings from './../model/userSettings';
import FormSystemError from '../utils/form-error-constants';
import common from  './../module/common';

let Deserializer = JSONAPISerializer.Deserializer;

let checkNavForIE = () => {
    let productMenuJQ;
    let floatBuyButton;
    let isIE = document.body.style.msTouchAction !== undefined;
    let productMenuTop = 50;
    let buyButtonHeight;
    let anchorMenuSpace;
    let productContainer;
    let endOfProductContainer;

    if (isIE) {
        floatBuyButton = $(".floatBuyButton");
        productMenuJQ = $("#productMenu");
        anchorMenuSpace = $(".anchorMenuSpace");
        productContainer = $('.main-cont > .productContainer');
        buyButtonHeight = floatBuyButton.innerHeight();
        endOfProductContainer = productContainer.height() + productContainer.position().top;

        if ($(document).scrollTop() > (anchorMenuSpace.position().top + 150)){
            productMenuJQ.css({position:'fixed', top:buyButtonHeight + productMenuTop})
        }

        if($(document).scrollTop() > (endOfProductContainer - 200)){
            productMenuJQ.css({position:'absolute', top:'auto'});
        }

        if($(document).scrollTop() < anchorMenuSpace.position().top){
            productMenuJQ.css({position:'absolute', top:'auto'});
        }
    }
};

let checkToShowFloatBuyButton = (component) => {
    let isNeededToShow;
    let buyButtonPosition;
    let scrollPosition;
    let mq = window.matchMedia( "(max-width: 740px)" );

    if (component.$store) {
        if ((component.$store.state.currentView === "product") && ($(".productSpecs .button.cart")[0])) {
            buyButtonPosition = $(".productSpecs .button.cart")[0].offsetTop;
            scrollPosition = $(document).scrollTop();
            isNeededToShow = scrollPosition > buyButtonPosition;

            if(isNeededToShow && mq.matches){
                $('header').css("display", "none");
            } else {
                $('header').css("display", "block");
            }

            checkNavForIE(component);
        } else {
            $('header').css("display", "block");
        }

        component.$store.commit('setVisibilityFloatBuyButton', isNeededToShow);
    }

};

let addSeoEvents = () => {
    let seoButtons = $('.readMore .button');
    let buttonMinus;
    let buttonPlus;
    let textMore = $('.text.more');

    if(seoButtons.length){
        buttonMinus = $(seoButtons[1]);
        buttonPlus = $(seoButtons[0]);

        buttonMinus.css('display', 'none');
        textMore.css('display', 'none');
    }

    seoButtons.click(function (event) {
        if(buttonMinus.css('display') === 'none'){
            buttonPlus.css('display', 'none');
            buttonMinus.css('display', 'block');
            textMore.css('display', 'block');
        } else {
            buttonMinus.css('display', 'none');
            buttonPlus.css('display', 'inline-flex');
            textMore.css('display', 'none');
        }
    });
};

let hideMenu = (component, mainNavBar) => {
    component.showMainNav = false;
    module.removeClass(mainNavBar, "is-active");
};

let showMenu = (component, mainNavBar) => {
    component.showMainNav = true;
    module.addClass(mainNavBar, "is-active");
};

let hideHeaderAnimated = () => {
    const header = $('header');
    const screenBeforeMedium = window.matchMedia( "(max-width: 980px)" );
    const screenLaptop = window.matchMedia( "(max-width: 1024px)" );

    $('header .slides.tns-slider').css('transition', 'none');
    module.addClass(header[0], 'is-scrollingDown');
    header.stop();

    if(!screenLaptop.matches){
        $('header .usps').css('display', 'none');
    }

    if(screenBeforeMedium.matches){
        header.animate({top:'-9rem'});
    } else {
        // $('.usps').css('display', 'none');
        header.animate({top:'-6rem'});
    }
};

let showHeaderAnimated = () => {
    const header = $('header');
    const screenLaptop = window.matchMedia( "(max-width: 1024px)" );

    $('.desktop-float-buy-button .float-buy-button-container').promise().then(function() {
        module.removeClass(header[0], 'is-scrollingDown');

        $(header).stop();
        $(header).animate({top:'0'});

        $('header .slides.tns-slider').css('transition', 'all 0s');
    });

    if(!screenLaptop.matches){
        $('header .usps').css('display', 'block');
    }
};

let setHeaderHeight = () => {
    const header = $('header');
    const screenBeforeMedium = window.matchMedia( "(max-width: 980px)" );

    $(header).promise().then(function() {
        if(screenBeforeMedium.matches){
            $(header).css({top:'-9rem'});
        } else {
            $(header).css({top:'-6rem'});
        }
    });
};

let isSPA = (component) => {
    return component.$store;
};

let scrollHandler = (component) => {
    const headerEl = document.querySelector('header');
    const headerH = $(headerEl) ? $(headerEl).height() : 0;
    const screenBeforeSmall = window.matchMedia( "(max-width: 740px)" );

    checkToShowFloatBuyButton(component);

    if (! $(headerEl).length || screenBeforeSmall.matches) {
        return false;
    }

    let mainNavBar = document.querySelector('.js-mainNavBar');
    let distanceY = window.pageYOffset || document.documentElement.scrollTop,
        shrinkOn = headerH,
        header = (headerEl);
    if (distanceY > shrinkOn) {
        if(isSPA(component)){

            if(!$(headerEl).hasClass('is-scrollingDown')){
                hideHeaderAnimated();
            } else {
                setHeaderHeight();
            }

        } else {
            module.addClass(headerEl, 'is-scrollingDown');
        }

        if(module.isNeededSpecialMenuBehavior()){
            hideMenu(component, mainNavBar);
        }

    } else {
        if(isSPA(component)){
            if($(headerEl).hasClass('is-scrollingDown')){
                showHeaderAnimated();
            }
        } else {
            module.removeClass(headerEl, 'is-scrollingDown');
        }

        if(module.isNeededSpecialMenuBehavior()){
            showMenu(component, mainNavBar);
        }
    }
};

let isNewsletterLink = () => {
    let utmSource = window.location.search.indexOf('utm_source') !== -1;
    let utmMedium = window.location.search.indexOf('utm_medium') !== -1;
    let utmCampaign = window.location.search.indexOf('utm_campaign') !== -1;

    return utmSource && utmMedium && utmCampaign;
};

let addMenuEventListeners = (b, h, objectJQ, subH) => {
    let arrFunction = (a) => {
        b.push({
            x: a.pageX,
            y: a.pageY
        });
        10 < b.length && b.pop();
    };

    let timeoutId;

    objectJQ.mouseenter((event)=>{
        $(event.currentTarget).on("mousemove", arrFunction);
        let pageX = event.pageX;
        let pageY = event.pageY;
        let noChildInActiveBlock = !subH && !$('.level02 .active-block').length;
        let allSubClosed = !objectJQ.siblings('div').hasClass('active-block');

        if(subH){
            subH = {value:null};
            $(event.currentTarget).parent().find('.level01 .level02').removeClass('active-block');
        }

        if (!h.value){
            $(event.currentTarget).siblings('div').addClass('active-block');
            return
        }

        pageX = 180 * Math.atan2(h.value.y - pageY, h.value.x - pageX) / Math.PI;

        if(timeoutId){
            clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(()=>{
            let currentCategory;

            if($(event.currentTarget).css('color') === 'rgb(255, 107, 0)'){
                currentCategory = true;
            }

            if(( -120 < pageX && 120 > pageX) || noChildInActiveBlock || allSubClosed || currentCategory){

                if(!($(".mainItem > a:hover").length && !$(event.currentTarget).parent().hasClass('mainItem'))){
                    objectJQ.siblings('div').removeClass('active-block');
                    $(event.currentTarget).siblings('div').addClass('active-block');
                }
            }
        }, 200)
    });

    objectJQ.mouseleave((c)=> {
        $(c.currentTarget).off("mousemove", arrFunction);
        h.value = b[b.length - 1];
        b = [];
    });
};

let afterFetchProductInfo = (component) => {
    if(component.$store.state.viewParams){

        if(component.$store.state.viewParams.scrollPosition){
            component.$nextTick(() => {
                $('html, body').scrollTop(component.$store.state.viewParams.scrollPosition);
            });
        }

        if(!component.$store.state.viewParams.backButton){
            window.scrollTo(0, 0);
        }
    }
};

let newsletterFormReceivedAnswer = (form, parent, input, noticeAfter, data) => {
    let $form = $(form);
    let $parent = $(parent);
    let $input = $(input);
    let $noticeAfter = $(noticeAfter);

    let formSystemError = new FormSystemError($form);

    formSystemError.hideNoticeErrorNext($input, $noticeAfter, formSystemError.constants.clang_newsletter_subscription_failed);

    if (data.statusCode === 2) {
        $parent.find('.notification.newsletter.subscribed').find('.customer_email').html($form.find('input[name=email]').val());
        $parent.find('.notification.newsletter.subscribed').removeClass('hidden');
        return;
    }

    if (data.statusCode === 0 || data.statusCode === 3) {
        formSystemError.showNoticeErrorAfter($input, $noticeAfter, formSystemError.constants.clang_newsletter_subscription_failed);
        return;
    }
    $parent.find('.notification.newsletter.success').removeClass('hidden');
};

let newsletterFormhideNotifications = ($parent) => {
    $parent.find('.notification.newsletter.failed').addClass('hidden');
    $parent.find('.notification.newsletter.success').addClass('hidden');
    $parent.find('.notification.newsletter.subscribed').addClass('hidden');
};

let prepareRequestData = (params) => {
    let footerNewLetter = $('.footerTop form');
    let footerParams = footerNewLetter.serialize();
    let positionCaptchaParams = footerParams.indexOf('&g');
    let captchaParams = footerParams.substr(positionCaptchaParams);

    return `${params}${captchaParams}`;
};

let module = {
  userData: {},
  sendNewsletterRequest(requestData){
        return $.ajax({
            url: '/?action=newsletter/subscribe',
            type: 'POST',
            data: requestData,
        })
    },
    getCookie(cname){
        let name = `${cname}=`;
        let cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return "";
    },
    setCookie(cname, cvalue, exdays){
        let date = new Date();
        date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = `expires=${date.toUTCString()}`;
        document.cookie = `${cname}=${cvalue};${expires};path=/`;
    },
    addAdditionalMenuEventListeners(){
        let currentMenuListJQ;
        let currentMenuListOpened;
        let $menuList;

        $(document).ready(function () {
            $('.topBar nav .mainItem > a').click((event)=>{
                $menuList = $('.topBar nav .mainItem .menu-list');
                event.preventDefault();

                currentMenuListJQ = $(event.currentTarget).parent().find('.menu-list');
                currentMenuListOpened = currentMenuListJQ.hasClass('is-active');

                $menuList.removeClass('is-active');

                if(!currentMenuListOpened){
                    module.addClass(currentMenuListJQ[0], 'is-active');
                }

                $(document).on('click', handleClickOutside);
            });

            function handleClickOutside(event) {
                if(!$(event.target).closest('.mainItem').length){
                    $menuList.removeClass('is-active');
                }
            }

        });
    },
    fetchRenderProductInfo(component, product, callback){
        Promise.all([
            component.$store.dispatch('getProduct', product.id),
            component.$store.dispatch('getRelatedProducts', product.id),
            component.$store.dispatch('getQuestions', product.commonId),
            component.$store.dispatch('getReviews', {commonId:product.commonId}),
            component.$store.dispatch('getRecommendations', product.id)
        ]).then(([product, relatedProducts, questions, reviews, recommendations]) => {
            component.$store.dispatch('renderRecommendations', recommendations);
            component.$store.dispatch('renderReviews', {reviews:reviews, component:component});
            component.$store.dispatch('renderRelatedProducts', relatedProducts);
            component.$store.dispatch('renderQuestions', questions);
            component.$store.dispatch('renderProduct', product);

            callback(component);
        })

    },
    getSpecWarning(variation) {
        if (variation && variation.specificationName) {
            return variation.specificationName.toLowerCase()
        }
        return variation.specification && variation.specification.length ? variation.specification[0].name.toLowerCase() : ''
    },
    menuAngle(){
        let b1 = [];
        let h1 = {value:null};
        let b2 = [];
        let h2 = {value:null};
        let mainNavigation = $('.mainNavigation');
        let firstLevel = mainNavigation.find('.mainItem > a');
        let secondLevel = mainNavigation.find('.mainItem > .level02 li a:not(.menuLastLevel)');

        addMenuEventListeners(b1, h1, firstLevel, h2);
        addMenuEventListeners(b2, h2, secondLevel);

        $('.foreground').mouseleave((c)=> {
            setTimeout(()=>{
                $('.level02').siblings('div').removeClass('active-block');
                $('.mainItem > .has-sub').siblings('div').removeClass('active-block');
            },200);
        });
    },
    isNeededSpecialMenuBehavior(){
        if(window.location.pathname === '/') {
            return !window.location.search || isNewsletterLink()
        }
    },
    closeMainNav (component) {
        component.showMainNav = false;
    },
    dropDownProfileClick (component) {
        component.showAccount = !component.showAccount;
    },
    setGdprCookie(component){
        $('body').removeClass('showCookieBar');
        component.gdprCookieExists = true;
    },
    gdprCookieInit(component){
        const oldGdprCookie = component.$cookie.get('gdprCookie');
        component.gdprCookieExists = component.$cookie.get('__Host-gdprCookie') !== null
          || oldGdprCookie !== null;
        if (oldGdprCookie) {
            component.$cookie.delete('gdprCookie');
        }

        if (!component.gdprCookieExists){
            $('body').addClass('showCookieBar');
            component.$cookie.set('__Host-gdprCookie', true, { expires: '1Y', secure: true });
        }
    },
    isObjectsEquivalent(a, b){
        let aObject = JSON.parse(JSON.stringify(a));
        let bObject = JSON.parse(JSON.stringify(b));
        let aProps = Object.getOwnPropertyNames(aObject);
        let bProps = Object.getOwnPropertyNames(bObject);

        // If number of properties is different,
        // objects are not equivalent
        if (aProps.length != bProps.length) {
            return false;
        }

        for (let i = 0; i < aProps.length; i++) {
            let propName = aProps[i];

            // If values of same property are not equal,
            // objects are not equivalent
            if (JSON.stringify(aObject[propName]) !== JSON.stringify(bObject[propName])) {
                return false;
            }
        }

        // If we made it this far, objects
        // are considered equivalent
        return true;
    },
    setCartInfo(){
        $.ajax({url: "?action=cart/cartAmount", cache: false}).done((response)=>{
            $('div.cart .quantity').text(response.quantity);
        })
    },
    getUserLoggedStatus (component) {
      return UserSettings.getCurrentUser().then(function (userData) {
        if (userData) {
          if (component.$store) {
            component.$store.state.isLogged = userData.isLogged;
            component.$store.commit('setUser', userData);
          }
          common.userData = userData;
          common.fillOutUserHeader(userData);
        }
      });
    },
    getUserInfo(component){
      common.getStockMessage(component);
      common.getUserLoggedStatus(component);
    },
    concatChildrenAndParent(product){
        if(product.variations && product.variations.length){
            return product.variations;
        } else if (product.specification) {
            return [product.variations];
        }

        return [];
     },
    changeMainProduct(component, product) {
        let lastParams = history.state;

        if(lastParams && (lastParams.currentView === 'product')){
            module.fetchRenderProductInfo(component, product, afterFetchProductInfo);
        }
    },
    attachSeoComponent(seoText) {
        Vue.component('SeoBlock', function(resolve, reject){
            resolve({
                data: function () {
                    return {
                        templ:''
                    }
                },
                template: "<div v-html='templ'></div>",
                mounted(){
                    addSeoEvents();
                },
              created(){
                this.templ = "<div>" + $("<div/>").html(seoText).text() + "</div>";
              }
            });
        });
    },
    initScroll(component){
        scrollHandler(component);

        window.addEventListener('scroll', function (e) {
            scrollHandler(component);
        });
    },
    getMenuContent(component) {
        let menuContent = {};

        if(window.desktopMenu){
            new Deserializer().deserialize(window.desktopMenu.mobile.original, function (err, mobile) {
                menuContent.mobile = mobile;
                component.menuContent = menuContent;
            });
        }
    },
    getStockMessage(component) {
        return new Promise((resolve) => {
            $.getJSON(window.env.baseUrl + '/?action=Index/stockMessage').done((response) => {
                component.stockMessage = $('<div></div>').html(response.message);
                resolve();
            }).fail((jqXHR, textStatus, errorThrown) => {
                console.log('common.getStockMessage(): ' + errorThrown);
                resolve();
            });
        });
    },
    popstateHandler : (that) => {
        return (popstateObj) => {

            if(popstateObj.state){
                let queryparams = popstateObj.state.queryparams;
                let scrollPosition = popstateObj.state.scrollPosition;

                if(queryparams.prodlevid){
                    that.$root.showModalCart = false;
                    that.$store.commit('setView', {viewName:'product', viewParams:{id:queryparams.prodlevid, url:queryparams.url, commonId:queryparams.commonId, backButton:true, scrollPosition:scrollPosition}});
                    module.changeMainProduct(that, {id:queryparams.prodlevid, url:queryparams.url, commonId:queryparams.commonId});
                } else if(queryparams.categoryId){
                    that.$store.commit('setView', {viewName:'theme',  viewParams:{categoryId:queryparams.categoryId, categoryUrl:queryparams.categoryUrl, backButton:true, scrollPosition: scrollPosition}});
                } else if(queryparams.reviewProduct){
                    that.$store.commit('setView', {viewName:'review', viewParams:{reviewProduct:queryparams.reviewProduct, backButton:true, scrollPosition:scrollPosition}});
                } else {
                    that.$store.commit('setQueryParams',  queryparams);
                    that.$store.dispatch('productsFiltersRequest', {backButton:true, scrollPosition:scrollPosition});
                }
            } else {
                history.back();
            }
        }
    },
    checkVariarionsForRequest(variations, specChecked){
        return !(variations.length && !specChecked);
    },
    addTippy: () => {
        tippy('.tooltip', {
            dynamicTitle: true,
            position: 'right',
            arrow: true,
            popperOptions: {
                modifiers: {
                    flip: {
                        behavior: ['right', 'top']
                    }
                }
            }
        });

        tippy('.tooltip-like', {
            position: 'top',
            arrow: true,
            dynamicTitle: true
        });
    },
    dropdownFocusOut : () => {
        let dropdown = document.querySelectorAll('.dropdown');
        for (let i = dropdown.length - 1; i >= 0; i--) {
            module.removeClass(dropdown[i], 'is-active');
        }
    },
    removeClass : (element, className) => {
        if (element.classList) {
            element.classList.remove(className);
        }
        else {
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    },
    addClass : (element, className) => {
        if (element.classList) {
            element.classList.add(className);
        }
        else {
            element.className += ' ' + className;
        }
    },
    toggleClass : (element, className) => {
        let classes;
        let existingIndex;

        if (element.classList) {
            element.classList.toggle(className);
        } else {
            classes = element.className.split(' ');
            existingIndex = classes.indexOf(className);

            if (existingIndex >= 0)
                classes.splice(existingIndex, 1);
            else
                classes.push(className);

            element.className = classes.join(' ');
        }
    },
    checkFormFields : (formData, excluded) => {
        excluded = excluded || [];

        for (let field in formData){
            if (excluded.indexOf(field) === -1 && !formData[field]) {
                return false;
            }
        }

        return true;
    },
    isCurrentView : (value, currentView) => {
        return currentView === value
    },
    transformBundleCartProduct: (item) => {
        item.vendor = item.getvendorname;
        item.name = item.getname;
        return item;
    },
    whistlistAction: (prodLevId, method) => {
        let url = `/?action=wishlist/${method}&prodLevId=${prodLevId}`;
        if (window.csrf_token) {
            url = url + `&_token=${window.csrf_token}`;
        }

        return $.get(url);
    },
    onSendEmailAnchor() {
        let $anchor = $(".customerserviceContainer .contactContainer a[href='#sendEmail']");
        let $anchorLink = $anchor.attr('href');

        $anchor.on("click", function (e) {
            this.scrollToAnchor($anchorLink);
            e.preventDefault();
            return false;
        }.bind(this));

        // Decline navigation to anchor if page was reloaded and accept if anchor appeared in a link
        if (window.location.href.indexOf('#sendEmail') !== -1 && performance.navigation.type === 0) {
            this.scrollToAnchor($anchorLink);
        }
    },
    onServiceFaqAnchor() {
        $(".customerserviceContainer .mainContent a[href*='#']").on("click", function (e) {
            this.scrollToAnchor($(e.target).closest("a").attr('href'));
            e.preventDefault();
            return false;
        }.bind(this));

        // Decline navigation to anchor if page was reloaded and accept if anchor appeared in a link
        if (/(?=.*klantenservice)(?=.*\#).*/.test(window.location.href)) {
            let urlWithAnchor = window.location.href.match(/\#(.*)/);
            if (urlWithAnchor) {
                let anchor = $("section#" + urlWithAnchor[1]);

                this.scrollToAnchor(anchor);
                let cookieBarCont = $('.cookie-bar-cont');
                let cookieBarContParent = cookieBarCont.parent();
                if (cookieBarCont.is(':visible')) {
                    if (cookieBarContParent.not('.header-checkout')) {
                        cookieBarContParent.css('transform', 'none');
                    }
                }
            }
        }
    },
    scrollToAnchor(anchor) {
        if(!$(anchor).length){
            return
        }

        $('html, body').stop().animate({
            scrollTop: $(anchor).offset().top - 140
        }, 1000);
    },
    prepareCartLines(cartLines) {
        let newArr = [];

        for(let i = 0; i<cartLines.length; i++){
            newArr.push(this.transformBundleCartProduct(cartLines[i]));

            if(!cartLines[i].isproduct && cartLines[i].bundledproducts){
                cartLines[i].isBundled = true;
                for (let j = 0; j<cartLines[i].bundledproducts.length; j++) {
                    if (j > 0) {
                        cartLines[i].bundledproducts[j-1].isBundled = true;
                    }
                    cartLines[i].bundledproducts[j].isSubBundle = true;
                    cartLines[i].bundledproducts[j].vendor = cartLines[i].bundledproducts[j].vendorName;
                    newArr = newArr.concat(cartLines[i].bundledproducts[j]);
                }
            }
        }

        return newArr;
    },
    changeWishlistTextTitle(element, method) {
        if(method === 'add'){
            $(element).attr('title', this.getProductWishlistText(true));
        } else{
            $(element).attr('title', this.getProductWishlistText(false));
        }
    },
    getProductWishlistText(inWishlist) {
        if (inWishlist) {
            return 'Remove from wish list';
        }

        return 'Add to wish list';
    },
    dropDownAccount(component) {
      if (! common.userData.isLogged) {
        window.location.href = `${window.env.baseUrl}/?action=auth/login`;
        return;
      }

      component.showAccount = !component.showAccount;
      component.showCart = false;
      component.focused = false;
    },
    fillOutUserHeader(userData) {
      let userName;

      if (userData) {
        if (userData.isLogged) {
          userName = userData.user_name;
          common.fillOutUserNameHeader(userName);
          common.fillOutSearchPlaceholder(userName);
        } else {
          common.fillOutUserUnLoggedHeader();
        }
        let cartLineCount = +userData.cartLineCount;
        common.setCartInfo(cartLineCount);
      }
    },
    fillOutSearchPlaceholder(userName) {
      let fcSearch = $('#fc_search');
      let customerPlaceholder = fcSearch.data('customerplaceholder');
      let placeholder = userName + customerPlaceholder;
      fcSearch.attr("placeholder", placeholder);
    },
    fillOutUserNameHeader(userName) {
      let accountHeader = $('.accountHeader');
      accountHeader.find('.userName').text(userName).html();
    },
    fillOutUserUnLoggedHeader() {
      common.fillOutUserNameHeader('Log In');
    },
    fitIEImages(selector, options) {
        objectFitImages(selector, options);
    },
    addMetaTags(meta) {
        let title  = meta.title || 'Search | FUTURUM Quality Gear';
        let description  = meta.description || '';

        this.fillMeta(title, description);
        this.fillFacebookMeta(title, description);
    },
    fillMeta(title, descriptions, setCanonical) {
        document.title = title;
        setCanonical = setCanonical || window.location.href;
        let descriptionHeader = document.querySelector('meta[name="description"]');
        if (descriptionHeader) {
            descriptionHeader.setAttribute('content', descriptions);
        }

        let linkCanonical = document.querySelector('link[rel="canonical"]');
        if (linkCanonical) {
            linkCanonical.setAttribute('href', setCanonical);
        }
    },
    fillFacebookMeta(title, descriptions, image) {
        let titleHeader = document.querySelector('meta[property="og:title"]');
        if (titleHeader) {
            titleHeader.setAttribute('content', title);
        }
        let descriptionHeader = document.querySelector('meta[property="og:description"]');
        if (descriptionHeader) {
            descriptionHeader.setAttribute('content', descriptions);
        }

        let imageHeader = document.querySelector('meta[property="og:image"]');
        if (imageHeader && image) {
            imageHeader.setAttribute('content', image);
        }

        let ogUrl = document.querySelector('meta[property="og:url"]');
        if (ogUrl) {
            ogUrl.setAttribute('content', window.location.href);
        }
    },
    redirectToCart() {
        window.location.href = window.env.baseUrl + '?action=cart';
    },
    hideOnClickOutside(selector, callback) {
        const outsideClickListener = (event) => {
            if (!$(event.target).closest(selector).length) {
                if ($(selector).is(':visible')) {
                    callback();
                    removeClickListener()
                }
            }
        };

        const removeClickListener = () => {
            document.removeEventListener('click', outsideClickListener)
        };

        document.addEventListener('click', outsideClickListener)
    },
    asyncSendPageGoogleAnalytics() {
      if (typeof ga !== 'undefined') {
        ga('create', window.env.gaCode, 'auto');
        ga('send', 'pageview', location.pathname);
      }
    },
    addDataLayer(googleAnalyticDataLayer, removeDataLayer) {
        if (removeDataLayer) {
            this.removeDataLayer();
        }

        this.pushDataLayer(googleAnalyticDataLayer.getResult);
    },
    pushDataLayer(sendObject) {
        let dataLayer = window.dataLayer || [];
        dataLayer.push(sendObject);
    },
    removeDataLayer() {
        let gtmCode = window.gtmCode;
        let gtm;
        if(typeof window.google_tag_manager !== 'undefined') {
          gtm = window.google_tag_manager[gtmCode];
          gtm.dataLayer.set('page', undefined);
          gtm.dataLayer.set('marketing', undefined);
          gtm.dataLayer.set('ecommerce', undefined);
          gtm.dataLayer.set('user', undefined);
        }
    },
    refreshReviewRating(state, reviewRating) {
        this.setReviewRatingForProduct(window.staticData, reviewRating);
        /*for (let i = 0; i < state.relatedProducts.length; i++) {
            this.setReviewRatingForProduct(state.relatedProducts[i], reviewRating);
            let variations = this.concatChildrenAndParent(state.relatedProducts[i]);
            for (let j = 0; j < variations.length; j++) {
                this.setReviewRatingForProduct(variations[j], reviewRating);
            }
        }
        let variations = this.concatChildrenAndParent(state.currentProduct);
        for (let i = 0; i < variations.length; i++) {
            this.setReviewRatingForProduct(variations[i], reviewRating);
        }*/
    },
    setReviewRatingForProduct(product, reviewRating) {
        product.reviewRating.score = reviewRating.score;
        product.reviewRating.voted = reviewRating.voted;
    },
    getFixedProductRating: (product) => {
        return product.reviewRating.score ? Math.round(Number.parseFloat(product.reviewRating.score) * 10) / 10 : 0;
    },
    getButtonAddToCartTitle (component) {
        if (component.activeStock) {
            return 'Voeg toe aan winkelmand';
        }

        if (!component.activeStock && window.categoryUrl) {
            return 'Bekijk alternatieven';
        }

        return 'Niet meer leverbaar';
    },
    getButtonAddToCartClass(component) {
        let result = 'product-button-add';

        if (!component.activeStock && !window.categoryUrl) {
            result += ' disabled';
        }

        if (!component.activeStock && window.categoryUrl) {
            result += ' blue';
        }

        return result;
    },
    getStockColor(colorClass){
        let classObj = {};

        if(colorClass){
            classObj[colorClass] = true;
        }

        return classObj;
    },
    clickSizeTable(event, component){

        if(component.isMobile){
            $('html, body').scrollTop(0);
        }

        event.preventDefault();

        component.$root.showModal_anchorSizetable = !component.$root.showModal_anchorSizetable;
    },
    toggleSpecialProductVariations(event) {
        let shouldAddClass = !$(event.currentTarget.parentNode).hasClass('is-active');
        $('.modalContent .dropdown').removeClass('is-active');

        if(shouldAddClass){
            this.addClass(event.currentTarget.parentNode, 'is-active');
        } else {
            this.removeClass(event.currentTarget.parentNode, 'is-active');
        }
    },
    paginationClick(component, page) {
        let item = page.getItem;
        let lastPage = page.getLastPage;
        let currentPage = page.getCurrentPage;
        component.$store.commit('setCurrentPage', item);
        UserSettings.fillPagination(lastPage, currentPage);

        this.makeRequest(component);
    },
    paginationArrowClick(component, type) {
        UserSettings.paginationArrowClick(component, type);
        this.makeRequest(component);
    },
    makeRequest(component) {
        component.$store.commit('setPagination', {
            page:component.currentPage.number
        });

        component.$store.commit('setCurrentTrigger', 'pagination');

        component.$store.dispatch('productsFiltersRequest');
        component.$store.commit('setVisibilityMaxPage', component.currentPage);
    },
    clientDeviceType() {
        let MobileDetect = require('mobile-detect');
        return new MobileDetect(window.navigator.userAgent);
    },
    isMobile() {
        return !!this.clientDeviceType().mobile();
    },
    isTablet() {
        return !!this.clientDeviceType().tablet();
    },
    findProduct(product){
        let length = product.variations.length;
        let children = product.variations;
        let child;
        let defaultProductId = product.defaultProductId;
        let findProduct = product;

        for (let i = 0; i < length; i++) {
            child = children[i];
            if (child.id === defaultProductId) {
                findProduct = child;
                break;
            }
        }

        return findProduct;
    },
    sizeTableEventListener() {
      let popup = $('#showModal_size-table'),
        popupImage = $(popup).find('#showModal_size-table-image'),
        popupName = $(popup).find('#showModal_size-table-name'),
        popupDescription = $(popup).find('#showModal_size-table-description'),
        closeButton = $(popup).find('.modalClose'),
        overlay = $('.overlay-showModal');

      let openModal = (text, name, description) => {
        if (!$(popup).hasClass('is-active')) {
          $(popupImage).attr('src', text);
          $(popupName).html(name);
          $(popupDescription).html(description);
          $(popup).add(overlay).addClass('is-active');
          $('html, body').stop().animate({
            scrollTop: $(popup).get(0).offsetTop
          }, 1000);
        }
      };

      let closeModal = () => {
        if ($(popup).hasClass('is-active')) {
          $(popup).add(overlay).removeClass('is-active');
        }
      };

      $('.size-tables-link').on('click', (e) => {
        let elem = e.target;
        openModal(
          $(elem).attr('data-url'),
          $(elem).attr('data-name'),
          $(elem).attr('data-description')
        );
      });

      $(overlay).add(closeButton).on('click', () => {
        closeModal();
      });
    }
};

export default module
